import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import Box from "@mui/material/Box";
import { useCsCfgObject, } from "@plansoft-configuration-renderer/framework";
import { CommonComponentsContext } from "../Common/CommonComponents";
export function ConfigurationDescription(props) {
    var _a;
    const cfgObject = useCsCfgObject();
    const { Markdown } = useContext(CommonComponentsContext);
    const labelText = (_a = cfgObject.description) !== null && _a !== void 0 ? _a : "";
    const { textMode = "plaintext" } = props;
    const content = textMode === "markdown" ? _jsx(Markdown, { src: labelText }) : labelText;
    return _jsx(Box, { children: content });
}
//# sourceMappingURL=ConfigurationDescription.js.map